<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="ded"><a id="pagevii"></a><i>For Wayne</i></p>
<p class="ded1"><i>who gave me my first break in publishing.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?84358378